// extracted by mini-css-extract-plugin
module.exports = {"deliveryBlock":"DeliveryBlock_delivery-block__1blyk","deliveryBlockHorizontal":"DeliveryBlock_delivery-block-horizontal__E1Vcn"};